import { api } from "./api";
import type { GalleryCategory, GalleryItem } from "../types/Gallery";

export async function getGallery() {
  return api.get<{ success: boolean; items: GalleryItem[] }>("/gallery/");
}

export async function getGalleryCategories() {
  return api.get<{ success: boolean; categories: GalleryCategory[] }>(
    "/gallery-categories/"
  );
}

export async function createGalleryCategory(name: string) {
  return api.post<{ success: boolean; category: GalleryCategory }>(
    "/gallery-categories/",
    { name }
  );
}

export async function uploadGalleryItem(formData: FormData) {
  return api.upload<{
    success: boolean;
    id: number;
    message: string;
    media_type: "image" | "video";
    original_size: number;
    stored_size: number;
    processing_ms: number;
  }>(
    "/gallery/",
    formData
  );
}

export async function updateGalleryItem(
  id: number,
  data: Pick<GalleryItem, "category_id" | "caption" | "order_number">
) {
  return api.put<{ success: boolean; message: string }>(
    `/gallery/?id=${id}`,
    data
  );
}

export async function reorderGallery(itemIds: number[]) {
  return api.post<{ success: boolean; message: string }>(
    "/gallery/?action=reorder",
    { item_ids: itemIds }
  );
}

export async function deleteGalleryItem(id: number) {
  return api.delete<{ success: boolean; message: string }>(
    `/gallery/?id=${id}`
  );
}
